import { render, staticRenderFns } from "./SubscribeWeChat.vue?vue&type=template&id=48df5ca7&scoped=true&"
import script from "./SubscribeWeChat.vue?vue&type=script&lang=js&"
export * from "./SubscribeWeChat.vue?vue&type=script&lang=js&"
import style0 from "./SubscribeWeChat.vue?vue&type=style&index=0&id=48df5ca7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48df5ca7",
  null
  
)

export default component.exports